import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { Menu as MenuIcon, Search as SearchIcon } from "@mui/icons-material";
import { styled } from "@mui/system";
import quicktixlogo from "../../../../Images/GX_Logo_Black_No_Bg.png";
import { useNavigate, useLocation } from "react-router-dom";

const StyledToolbar = styled(Toolbar)({
  justifyContent: "space-between",
  maxWidth: "1400px",
  width: "100%",
  padding: "0px !important",
});

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleNavigation = (path) => () => {
    navigate(path);
  };

  const getNavButtonStyles = (path) => {

    return {
      ...navButtonStyles,
      backgroundColor:
        location.pathname === path ? "rgba(0, 0, 0, 0.05)" : null,
    };
  };

  const authToken = localStorage.getItem("authToken");

  const drawerList = (
    <Box
      sx={{ width: 250, alignItems: "center" }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {[
          { text: "Home", path: "/" },
          { text: "Explore Events", path: "/search" },
          { text: "My Tickets", path: "/mytickets" },
          { text: "About Us", path: "/about-us" },
           
          { text: "Contact Us", path: "/contact" },
        ].map((item) => (
          <ListItem
            button
            key={item.text}
            onClick={handleNavigation(item.path)}
          >
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <Box sx={{ p: 2, display: "flex", justifyContent: "center", flexDirection: 'column', gap: 2 }}>
        {authToken ? (<Button onClick={handleNavigation("/dashboard")} variant="contained" sx={{ ...buttonStyles, backgroundColor: "#535353", color: "white" }}>
          Dashboard
        </Button>) : (<>

          <Button onClick={handleNavigation("/register")} variant="outlined" sx={outlinedButtonStyles}>

            Sign Up
          </Button>

          <Button
            onClick={handleNavigation("/login")}
            variant="contained"
            sx={{ ...buttonStyles, ...transitionBtnStyles,backgroundColor: "#535353", color: "white" }}
          >
            Log In
          </Button>

        </>)}
      </Box>
    </Box>
  );

  return (
    <AppBar
      position="static"
      color="transparent"
      elevation={0}
      sx={{
        py: 1,
        px: 2,
        display: "flex",
        alignItems: "center",
        boxShadow: "none",
        borderBottom: "1px solid #ddd",
      }}
    >
      <StyledToolbar>
        <Box sx={{ cursor: "pointer" }} onClick={handleNavigation("/")}>
          <img src={quicktixlogo} alt="GX Tickets" style={{ height: "54px" }} />
        </Box>
        <Box
          sx={{
            display: { xs: "none", lg: "flex" },
            alignItems: "center",
            gap: "30px",
          }}
        >
          <Button sx={getNavButtonStyles("/")} onClick={handleNavigation("/")}>
            Home
          </Button>
          <Button
            sx={getNavButtonStyles("/search")}
            onClick={handleNavigation("/search")}
          >
            Explore Events
          </Button>
          <Button
            sx={getNavButtonStyles("/mytickets")}
            onClick={handleNavigation("/mytickets")}
          >
            My Tickets
          </Button>
          <Button
            sx={getNavButtonStyles("/about-us")}
            onClick={handleNavigation("/about-us")}
          >
            About Us
          </Button>
          <Button
            sx={getNavButtonStyles("/contact")}
            onClick={handleNavigation("/contact")}
          >
            Contact Us
          </Button>
        </Box>
        <Box
          sx={{
            display: { xs: "none", lg: "flex" },
            alignItems: "center",
            gap: "10px",
          }}
        >
          {authToken ? (
            <Button
              onClick={handleNavigation("/dashboard")}
              variant="contained"
              sx={{
                ...buttonStyles,
                ...transitionBtnStyles,
                backgroundColor: "#535353",
                color: "white",
              }}
            >
              Dashboard
            </Button>
          ) : (
            <>
              <Button
                onClick={handleNavigation("/register")}
                variant="outlined"
                sx={{...outlinedButtonStyles}}
              >
                Sign Up
              </Button>
              <Button
                onClick={handleNavigation("/login")}
                variant="contained"
                sx={{
                  ...buttonStyles,
                  ...transitionBtnStyles,
                  backgroundColor: "#535353",
                  color: "white",
                }}
              >
                Log In
              </Button>
            </>
          )}
        </Box>
        <IconButton
          color="inherit"
          edge="start"
          sx={{ display: { xs: "flex", lg: "none" } }}
          onClick={toggleDrawer(true)}
        >
          <MenuIcon />
        </IconButton>
        <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
          {drawerList}
        </Drawer>
      </StyledToolbar>
    </AppBar>
  );
};

export default Navbar;

const navButtonStyles = {
  fontSize: "14px",
  color: "#333",
  fontWeight: 500,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
};

const buttonStyles = {
  height: "40px",
  borderRadius: "4px",
  padding: "5px 15px",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
};

const transitionBtnStyles = {
  borderRadius: "4px",
  position: "relative",
  overflow: "hidden",
  transition: "background-color 0.3s, color 0.3s",
  "&:hover": {
    backgroundColor: "rgb(246,246,246)",
    color: "#535353",
  },
  "&::before, &::after": {
    content: '""',
    position: "absolute",
    width: "0%",
    height: "0%",
    borderStyle: "solid",
    borderColor: "#535353",
    transition: "width 0.3s ease, height 0.3s ease",
  },
  "&::before": {
    top: 0,
    left: 0,
    borderWidth: "2px 0 0 2px",
  },
  "&::after": {
    bottom: 0,
    right: 0,
    borderWidth: "0 2px 2px 0",
  },
  "&:hover::before, &:hover::after": {
    width: "100%",
    height: "100%",
  },
};

const outlinedButtonStyles = {
  ...buttonStyles,
  border: "1px solid #535353",
  color: "#535353",
  backgroundColor: "white",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
};
